document.addEventListener('DOMContentLoaded', () => {
  const productPanel = document.querySelector('[data-jr-diamond-product]');
  const productForm = document.querySelector('#MainContent product-form form:has(button[name="add"])') || document.querySelector('#MainContent form[data-al-product-form]:has(button[name="add"])');
  const productAnchor = productForm || document.querySelector('#MainContent #sisters-gift-button');
  if (productPanel && productAnchor) productAnchor.insertAdjacentElement('afterend', productPanel);
  const labels = document.querySelector('[data-jr-product-labels]');
  const productInfo = document.querySelector('#MainContent .product__info-container');
  if (labels && productInfo) {
    const special = labels.querySelector('[data-jr-diamond-special]');
    const labelText = labels.dataset.jrSpecialLabel.trim().toLowerCase();
    productInfo.querySelectorAll('.product__text, .caption-with-letter-spacing').forEach(existing => {
      if (existing.textContent.trim().toLowerCase() === labelText) existing.remove();
    });
    const title = productInfo.querySelector('.product__title');
    if (special && title) title.insertAdjacentElement('afterend', special);
    const stock = labels.querySelector('[data-jr-limited-stock]');
    const quantity = productInfo.querySelector('.product-form__quantity');
    const stockAnchor = quantity || productAnchor;
    if (stock && stockAnchor && !productInfo.querySelector('.limited-stock')) {
      stockAnchor.insertAdjacentElement('beforebegin', stock);
    }
    labels.remove();
  }
  if (document.querySelector('[data-jr-simple-purchase]')) {
    document.querySelectorAll('#MainContent form').forEach(form => {
      if (new URL(form.action, location.href).pathname !== (window.routes?.cart_add_url || '/cart/add')) return;
      const channel = document.createElement('input');
      channel.type = 'hidden';
      channel.name = 'properties[_JuneReedOffer]';
      channel.value = 'standard';
      form.append(channel);
    });
  }
});
